const MetaValuesAnswer = Object.freeze({
  READY_TO_DECLINE: 1,
  READY_DECLINE_TEMPORARY: 2,
  NOT_READY_TO_DECLINE: 3,
});

export default (MetaValuesAnswer);
